import { FC, useMemo } from "react";
import { InformationBarProps } from "../../information-bar.types";
import styles from "./information-bar-1.module.css";
import { useInformationBar } from "../../information-bar.hook";
import {
  useAnalytics,
  AppLink,
  InformationBarType } from
"@commons-monorepo/index";
import { INFORMATION_BAR_EVENTS } from "../../events";

const InformationBar1: FC<InformationBarProps> = ({
  information,
  offer,
  className,
  storeMetadata,
  ComponentLinks,
  ...props
}) => {
  const { t, showBar, offerLink, isInformationBarPreview } = useInformationBar({
    information,
    offer,
    storeMetadata,
    ...props
  });
  const [logEvent] = useAnalytics({ storeMetadata });
  const { selectedType, copy, darkMode, selectedIcon } = information;
  const selectOffer = () => {
    logEvent(INFORMATION_BAR_EVENTS.SELECT_INFOBAR_OFFER);
  };
  const copyFormat = useMemo(
    () =>
    String(selectedType).toUpperCase() === InformationBarType.CUSTOM ?
    copy :
    offer?.title || "",
    [offer, copy]
  );

  return (
    <aside
      className={`${styles.informationBar1} ${
      darkMode ? styles.informationBar1Dark : ""
      } ${showBar ? styles.show : ""} ${className}`}>

      <div className={styles.informationBar1Container}>
        {String(selectedType).toUpperCase() === InformationBarType.CUSTOM &&
        <>
            {selectedIcon && <span className={`icon-${selectedIcon}`} />}
            <h5 className={styles.text}>{copyFormat}</h5>
          </>}

        {String(selectedType).toUpperCase() === InformationBarType.OFFER &&
        <>
            {selectedIcon && <span className={`icon-${selectedIcon}`} />}
            <h5 className={styles.text}>{copyFormat}</h5>
            <AppLink
            className={styles.link}
            to={offerLink}
            Component={ComponentLinks}
            onClick={selectOffer}>

              {t("informationBar.viewOffer")}
            </AppLink>
          </>}

      </div>
      {isInformationBarPreview && <div className={styles.previewLayerOver} />}
    </aside>);

};

export default InformationBar1;